// Carte complète des wilayas voisines (58 wilayas d'Algérie)
// Utilisé par ShippingSettings pour proposer "tarif zone proche".
// Source partagée — éviter la duplication dans plusieurs composants.

export const WILAYA_NEIGHBORS = {
  "Adrar":["Béchar","Tamanrasset","In Salah","Timimoun","Béni Abbès","Bordj Badji Mokhtar"],
  "Chlef":["Aïn Defla","Tissemsilt","Relizane","Mostaganem","Tipaza"],
  "Laghouat":["Djelfa","Ghardaïa","El Bayadh","Tiaret","Médéa"],
  "Oum El Bouaghi":["Constantine","Mila","Batna","Khenchela","Souk Ahras","Guelma","Tébessa"],
  "Batna":["Oum El Bouaghi","Khenchela","Biskra","Sétif","Mila"],
  "Béjaïa":["Tizi Ouzou","Bouira","Bordj Bou Arréridj","Sétif","Jijel"],
  "Biskra":["Batna","Khenchela","El Oued","Ouargla","Djelfa","Sétif","M'Sila","Ouled Djellal","El M'Ghair"],
  "Béchar":["Adrar","Naâma","El Bayadh","Tindouf","Béni Abbès"],
  "Blida":["Alger","Tipaza","Médéa","Bouira","Aïn Defla"],
  "Bouira":["Alger","Blida","Médéa","Béjaïa","Tizi Ouzou","Bordj Bou Arréridj"],
  "Tamanrasset":["Adrar","In Guezzam","Djanet","In Salah","Bordj Badji Mokhtar"],
  "Tébessa":["Souk Ahras","Oum El Bouaghi","Khenchela"],
  "Tlemcen":["Oran","Sidi Bel Abbès","Naâma","Aïn Témouchent"],
  "Tiaret":["Relizane","Tissemsilt","Laghouat","Djelfa","Médéa","Aïn Defla","Mascara"],
  "Tizi Ouzou":["Alger","Boumerdès","Bouira","Béjaïa"],
  "Alger":["Boumerdès","Blida","Tipaza","Tizi Ouzou"],
  "Djelfa":["Laghouat","M'Sila","Biskra","El Bayadh","Tiaret","Médéa","Ouled Djellal"],
  "Jijel":["Béjaïa","Sétif","Mila","Skikda"],
  "Sétif":["Béjaïa","Jijel","Mila","Batna","Bordj Bou Arréridj","Bouira","M'Sila","Oum El Bouaghi"],
  "Saïda":["Sidi Bel Abbès","Mascara","Tiaret","Naâma","El Bayadh"],
  "Skikda":["Jijel","Mila","Constantine","Annaba","Guelma"],
  "Sidi Bel Abbès":["Tlemcen","Oran","Mascara","Saïda","Naâma"],
  "Annaba":["Skikda","Guelma","El Tarf"],
  "Guelma":["Annaba","El Tarf","Souk Ahras","Constantine","Skikda","Oum El Bouaghi"],
  "Constantine":["Mila","Oum El Bouaghi","Guelma","Skikda"],
  "Médéa":["Blida","Aïn Defla","Tissemsilt","Tiaret","Djelfa","Laghouat","Bouira","Alger"],
  "Mostaganem":["Oran","Relizane","Mascara","Chlef"],
  "M'Sila":["Bordj Bou Arréridj","Sétif","Batna","Biskra","Djelfa","Laghouat","Bouira","Ouled Djellal"],
  "Mascara":["Mostaganem","Oran","Sidi Bel Abbès","Saïda","Tiaret","Relizane"],
  "Ouargla":["El Oued","Biskra","Ghardaïa","Illizi","Touggourt","El M'Ghair","El Meniaa"],
  "Oran":["Mostaganem","Aïn Témouchent","Tlemcen","Sidi Bel Abbès","Mascara"],
  "El Bayadh":["Béchar","Naâma","Saïda","Tiaret","Laghouat","Adrar"],
  "Illizi":["Ouargla","Djanet","Tamanrasset"],
  "Bordj Bou Arréridj":["Sétif","Béjaïa","Bouira","M'Sila","Mila"],
  "Boumerdès":["Alger","Tizi Ouzou","Bouira"],
  "El Tarf":["Annaba","Guelma","Souk Ahras"],
  "Tindouf":["Béchar","Naâma"],
  "Tissemsilt":["Chlef","Aïn Defla","Médéa","Tiaret","Relizane"],
  "El Oued":["Biskra","Ouargla","Touggourt","El M'Ghair","Ouled Djellal"],
  "Khenchela":["Oum El Bouaghi","Batna","Tébessa","Biskra"],
  "Souk Ahras":["Guelma","El Tarf","Tébessa","Oum El Bouaghi"],
  "Tipaza":["Alger","Blida","Aïn Defla","Chlef"],
  "Mila":["Constantine","Sétif","Bordj Bou Arréridj","Jijel","Skikda","Oum El Bouaghi"],
  "Aïn Defla":["Tissemsilt","Chlef","Blida","Médéa","Tiaret","Tipaza"],
  "Naâma":["Béchar","El Bayadh","Saïda","Sidi Bel Abbès","Tlemcen","Tindouf"],
  "Aïn Témouchent":["Oran","Tlemcen","Sidi Bel Abbès"],
  "Ghardaïa":["Laghouat","El Bayadh","Ouargla","Djelfa","In Salah","El Meniaa"],
  "Relizane":["Mostaganem","Mascara","Tiaret","Tissemsilt","Chlef"],
  "Timimoun":["Adrar","In Salah","El Bayadh"],
  "Bordj Badji Mokhtar":["Adrar","Tamanrasset"],
  "Ouled Djellal":["Biskra","Djelfa","M'Sila","El Oued"],
  "Béni Abbès":["Béchar","Adrar"],
  "In Salah":["Adrar","Tamanrasset","Ghardaïa","Timimoun","El Meniaa"],
  "In Guezzam":["Tamanrasset"],
  "Touggourt":["Ouargla","El Oued","Biskra"],
  "Djanet":["Illizi","Tamanrasset"],
  "El M'Ghair":["El Oued","Biskra","Ouargla","Ouled Djellal"],
  "El Meniaa":["Ghardaïa","Ouargla","Adrar","In Salah"],
};
